const billingEvents = {

    seeBillingView: 'see_billing_view',

    openForm: 'open_form',
    clientValidationFailed: 'client_validation_failed',
    paymentBtnClicked: 'payment_btn_clicked',
    paymentSuccessful: 'payment_successful',

    // Billing form errors:
    getStripePaymentIntentError: 'get_stripe_payment_intent_error: ',
    proceedStripePaymentError: 'proceed_stripe_payment_error: ',
    stripeIsUnavailable: 'stripe_is_unavailable_error',

    // Paypal errors:
    paypalIsUnavailable: 'paypal_is_unavailable_error',
    paypalCreateOrderError: 'paypal_create_order_error: ',
    paypalOrderApprovedError: 'paypal_order_approved_error: ',
    paypalUnknownError: 'unknown_paypal_error',
    paypalWindowClosedByUser: 'paypal_window_closed_by_user_error',
   

    // Promocode form errors:
    promoCodeApplyError: 'apply_promo_code_error: ',

};

export default billingEvents;